import { render, staticRenderFns } from "./deal-page.vue?vue&type=template&id=39ae4f7c&scoped=true&"
import script from "./deal-page.vue?vue&type=script&lang=js&"
export * from "./deal-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae4f7c",
  null
  
)

export default component.exports